import { useStaticData } from "context/staticData";
import { SearchCriteriaProps } from "./types";
import { useCallback, useMemo } from "react";
import { useCopies } from "shared/hooks/useCopies";
import { useGetApplicableTagsForProgram } from "apps/console/modules/program/workflow/enrollment/list/dataLoader";
import { useFindEventAttendeeRegistrationFormsByRegistrationId } from "./dataloader";

export function useSearchCriteriaService(props: SearchCriteriaProps) {
  const staticData = useStaticData();
  const { data: tickets } = useFindEventAttendeeRegistrationFormsByRegistrationId({
    registrationId: props.registrationId || ""
  });
  const { data: programTagsConfig } = useGetApplicableTagsForProgram(props.programId);

  const copies = useCopies();

  const fields = useMemo(
    () => props.criteria.getFields(staticData, copies, programTagsConfig, tickets),
    [props.criteria, staticData, programTagsConfig, copies, tickets]
  );

  const initialValues = useMemo(
    () => props.criteria.getInitialValues(props.searchCriteriaItems),
    [props.criteria, props.searchCriteriaItems]
  );

  const validationSchema = useMemo(() => props.criteria.getValidationSchema(copies), [props.criteria, copies]);
  const handleSubmit = useCallback(
    (values: any) => {
      props.handleSubmit(props.criteria.handleSubmit(copies, values, staticData, programTagsConfig, tickets));
    },
    [props, copies, staticData, programTagsConfig, tickets]
  );

  return {
    fields,
    initialValues,
    handleSubmit,
    validationSchema
  };
}
